<div class="w-100">
    <div class="d-flex align-items-center pb-3">
        <div class="animated-icon"></div>
        <p class="text-secondary ps-2 mb-0">{{ genText$ | async }}</p>
        <div class="text-secondary" id="blinking-text"></div>
    </div>

    <!-- Skeleton equivalent Bootstrap 5: usa spinners o placeholder -->
    <div class="placeholder-glow mb-2 w-100">
        <span class="placeholder col-12"></span>
    </div>
    <div class="placeholder-glow mb-2" style="width: 60%;">
        <span class="placeholder col-6"></span>
    </div>
</div>